import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './stores';

// Tailwind CSS
import './assets/tailwind.css';

// Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css';

// Vue Toastification
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const app = createApp(App);

// Toastification 설정
const toastOptions = {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
};

app.use(router);
app.use(pinia);
app.use(Toast, toastOptions);
app.mount('#app');
